<template>
    <div>
        <v-row>
            
            <v-col cols="12" sm="12" md="6">
                <!-- <v-btn style="float:right;" color="primary" @click="showNewListDialog()">New</v-btn> -->
                
                <div class="text-h6 my-4 font-weight-black text-uppercase">
                    Lists
                    <v-btn icon @click="showNewListDialog()"
                        x-small
                        class="ml-2"
                        color="primary"
                        outlined
                    >
                        <v-icon>
                            mdi-plus
                        </v-icon>
                    </v-btn>
                </div>
                <!-- <div class="text-h4">Lists</div> -->
                <!-- <div v-for="list in lists.lists" :key="list.ID">{{list.post_title}}</div> -->
                <v-data-table
                    :headers="headers"
                    :items="lists.lists"
                    :items-per-page="10"
                    class="elevation-1"
                    :loading="lists.loading"
                    loading-text="Loading..."
                    :single-select="false"
                    item-key="ID"
                    :hide-default-footer="lists.lists.length <= 10"
                >
                    <!-- <template v-slot:item.actions> -->
                    <template v-slot:item.post_title="{ item }">
                        <div @click="goToList(item)" style="cursor:pointer;">{{item.post_title}}</div>
                    </template>

                    <template v-slot:item.post_date="{ item }">
                        <div @click="goToList(item)" style="cursor:pointer;">{{app.formatDateUTC(item.post_date)}}</div>
                    </template>

                    <template v-slot:item.actions="{ item }">
                        <v-btn icon @click="goToList(item)"><v-icon>mdi-eye</v-icon></v-btn>
                        <v-btn icon><v-icon>mdi-pencil</v-icon></v-btn>
                        <v-btn icon @click="confirmDelete(item)"><v-icon>mdi-delete</v-icon></v-btn>
                    </template>
                </v-data-table>
            </v-col>
            <v-col></v-col>
            <!-- <v-col></v-col> -->
        </v-row>

        <dialog-delete-list v-if="lists.show_delete_dialog"></dialog-delete-list>
        <!-- <dialog-delete-list></dialog-delete-list> -->

        <!-- BM: New List Dialog -->
        <v-dialog
            width="60%"
            max-width="500"
            v-model="show_new_list_dialog"
            persistent
        >
            <v-card>
                <v-card-title class="text-h5 primary">
                    New List
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="py-4">
                    <v-text-field outlined label="List name" v-model="new_list_name" :error="new_list_name_error"></v-text-field>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        @click="show_new_list_dialog = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        color="success"
                        @click="createList"
                        :loading="saving_list"
                        :disabled="saving_list"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { useListsStore } from '../stores/lists'
import { useAppStore } from '../stores/app'
import DialogDeleteList from './dialogs/DeleteList.vue'

export default {
    name: 'ListsAdmin',
    created() {
        this.lists = useListsStore()
        this.app = useAppStore()
        this.lists.fetchLists()
    },
    data: () => {
        return {
            lists: null,
            app: null,
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    sortable: true,
                    value: 'post_title',
                }, {
                    text: 'Created',
                    align: 'start',
                    sortable: true,
                    value: 'post_date'
                }, {
                    text: 'Actions',
                    value: 'actions',
                    align: 'center',
                    sortable: false
                }
            ],
            delete_list: null,
            saving_list: false,
            show_new_list_dialog: false,
            new_list_name: '',
            new_list_name_error: false
        }
    },
    methods: {
        showNewListDialog() {
            this.new_list_name = ''
            this.new_list_name_error = false
            this.show_new_list_dialog = true
        },
        goToList(list) {
            // this.lists.current_list = list
            // this.$router.push({ name: 'Home' })
            this.$router.push({ name: 'List', params: { id: list.ID }})
        },
        confirmDelete(list) {
            this.lists.list_to_delete = list
            this.lists.show_delete_dialog = true
        },
        createList: function () {
            if(this.new_list_name.length == 0) {
                this.new_list_name_error = true
                return
            }

            this.new_list_name_error = false
            this.saving_list = true
            this.app.req.post('lists', { post_title: this.new_list_name }).then(data => {
                this.saving_list = false
                this.show_new_list_dialog = false
                this.lists.fetchLists()
            })
        },
    },
    components: {
        DialogDeleteList
    }
}
</script>
